import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { ImageWithFallback } from './Utilities';
import { useCarContext } from '../CarContext';
import '../components/MyCarsLayout.css';
import inspectionImg from '../assets/inspection.svg';
import cameraImg from '../assets/camera.svg';
import carAuction from '../assets/car-auction.svg';
import takeDeliveryImg from '../assets/takeDelivery.svg';
import nocImg from '../assets/NOC.svg';
import payments from "../assets/payments.svg";

const MyCarsLayout = () => {
  const { carCount, uploadPicturesCount, placeBidsCount, paymentsCount, takeDeliveryCount, nocCount } = useCarContext();
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    {
      label: 'Inspection',
      path: '/mycars/inspection',
      img: inspectionImg,
      count: carCount,
    },
    { label: 'Upload Pictures', path: '/mycars/upload-pictures', img: cameraImg, count: uploadPicturesCount },
    { label: 'Place Bids', path: '/mycars/place-bids', img: carAuction, count: placeBidsCount },
    { label: 'Payments', path: '/mycars/payments', img: payments, count: paymentsCount },
    { label: 'Take Delivery', path: '/mycars/take-delivery', img: takeDeliveryImg, count: takeDeliveryCount },
    { label: 'NOC', path: '/mycars/noc', img: nocImg, count: nocCount },
  ];

  return (
    <div className="my-cars">
      <div className="container">
        <div className="tab-container">
          <div className="action-tabs">
            {tabs.map((tab) => (
              <div
                key={tab.path}
                className={`action-tab ${location.pathname === tab.path ? 'active' : ''}`}
                onClick={() => navigate(tab.path)}
              >
                <ImageWithFallback src={tab.img} alt={`${tab.label} Icon`} className="tab-icon" />
                <div className="tab-label">{tab.label}</div>
                {tab.count >= 0 && <div className="tab-badge">{tab.count}</div>}
              </div>
            ))}
          </div>
        </div>
        <Outlet />
      </div>
    </div>
  );
};

export default MyCarsLayout;